<template>
        <div class="tm-header">
            <div class="uk-navbar-container uk-navbar-transparent" animation="uk-animation-slide-top">
                <div class="uk-container uk-container-large">
                    <div class="uk-navbar" uk-navbar>
                        <div class="uk-navbar-left" >
                            <a target="_blank" href="https://help.artsdoor.net/" class="uk-navbar-item uk-logo">
                                <img src="../assets/logo.png" class="uk-responsive-height" alt="Juno">
                            </a>
                        </div>
                        <div class="uk-navbar-center">
            
                        </div>
                        <div class="uk-navbar-right">
                            <div class="uk-navbar-item">
                                <div class="custom contactus">
                                    <a class="uk-button uk-button-text" href="#Contact"><i class="iconfont icon-xin"></i> 联系我们</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>

export default {
  name: 'top',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  mounted:function(){
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .tm-header{
        padding:20px 10px;
        position: relative;
        background: #E6E6E6;
        /*margin-bottom:30px;*/
    }
      .tm-header:before, .tm-header:after{
        content:"";
        position: absolute;
        z-index: -1;
        box-shadow: 0 0px 15px rgba(162, 162, 162, 0.8);
        top: 50%;
        bottom: 0;
        left: 10px;
        right: 10px;
        border-radius: 30%;
    }
    .uk-button .iconfont{
        position: relative;
        top: 1px;
    }
     .contactus .uk-button-text{
         font-size:17px;
     }
     .contactus i{
         font-size:20px;
     }

    @media (max-width: 960px){
        .tm-header{
          padding: 5px;
        }
        .uk-navbar-left img{
            height:60px;
        }
    }


</style>



// WEBPACK FOOTER //
// Top.vue?db5e7990